import color from "../../constants/color";

const styles = {
  main:{ display: "flex",
    "& .css-12i7wg6-MuiPaper-root-MuiDrawer-paper":{border:"none"} 
  },
  profile:{
    width: "100px",
    height:"100px",
    borderRadius: "50%",
    objectFit: "cover",
    mb:2
    
  },
  heading:{
    fontSize:"16px",
    fontWeight:"400",
    lineHeight:"24px",
    textAlign: "center",
    color: color.text
    //  pt: 4,
  },
  subHeading:{
    fontSize:"12px",
    fontWeight:"400",
    lineHeight:"24px",
    textAlign: "center",
    color: color.text
  },
  logo:{
    width:"100%",
    display:"flex",
    justifyContent:"center",
    marginTop:"22px"
    // flexDirection: "column"
  },
  align:{
    flexDirection:"column",
    alignItems:"center",
    marginTop:"20%"
  },
  button:{
    backgroundColor: color.primary, 
    borderRadius: "30px",
    color:color.card,
    display:"flex",
    flexDirection:"row",
    alignItems:"center",
    justifyContent:"center",
    width:"100%",
    px:2,
    py:1
  },
  buttonInactive:{
    borderRadius: "30px",
    color:color.black,
    display:"flex",
    flexDirection:"row",
    alignItems:"center",
    justifyContent:"center",
    width:"100%",
    px:2,
    py:1
  },
  listItemButton:{p:0,
    my:1,
    ":hover": {
      borderRadius:"30px"
    },},
  margin:{
    marginX:"20px"
  },
  activeClr:{
    color:`${color.primary} !important`,
    borderRadius: "30px",
    p:1,
    // paddingRight:8
  },
  inactiveClr:{
    color:color.text,
    borderRadius: "30px",
    p:1,
    // paddingRight:4
  },
  marginLeft:{
    marginLeft: "10px",
    color:color.text
  }
};

export default styles